import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import imagesLoaded from 'imagesloaded';
import { MetaService } from '../../../services/meta.service';

declare var $: any;

@Component({
  selector: 'app-our-projects',
  templateUrl: './our-projects.component.html',
  styleUrls: ['./our-projects.component.scss']
})
export class OurProjectsComponent implements OnInit, AfterViewInit, OnDestroy {
  private domUpdateTimeout: any;

  imageUrl!: string;
  contentTitle = 'Complete IT Solutions Provider - XipeTech';
  contentDescription = 'Welcome to XipeTech, We provide the most responsive and functional IT Services. Invest your money in Developing a Brand, not just a website';
  contentKeywords = 'Technology Software, Web Development, API integration, PHP Development, Next.js development, React.js development, Node.js development, CMS Development, MVC Development, Android Application, iPhone Application, UI/UX Designing, UI Designing, 3D Designing, Logo Designing, Cloud computing, Artificial intelligence, Data analytics, Cybersecurity, Web development, Mobile app development, IT consulting, Virtual reality, Augmented reality, Web design Website development, Front-end development, Back-end development, Full-stack development, Responsive design, User interface (UI), User experience (UX), Custom web development, E-commerce development, Laravel development, Yii development, Codeigniter development, Content management systems (CMS), WordPress development, Drupal development, Magento development, Shopify development, Mobile-friendly websites, Cross-browser compatibility, Web application development, API integration, Website maintenance';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  constructor(private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }

  ngAfterViewInit(): void {
    this.domUpdateTimeout = setTimeout(() => {
      this.applyDomManipulations();
    }, 0);
  }

  private applyDomManipulations(): void {
    if ($('.case-area').length > 0) {
      // Wait until images are loaded
      imagesLoaded($('.grid'), () => {
        const projectGrid = $('.grid').isotope({
          itemSelector: '.grid-item',
          percentPosition: false,
          transitionDuration: '0',
          masonry: {
            columnWidth: '.grid-item'
          }
        });
        projectGrid.isotope({ filter: '.case0' });

        $('.case-menu').on('click', 'button', function () {
          const filterValue = $(this).attr('data-filter');
          projectGrid.isotope({ filter: filterValue });
          $('.case4-btn').removeClass('active');
          $(this).addClass('active');
        });
      });
    }
  }

  ngOnDestroy(): void {
    if (this.domUpdateTimeout) {
      clearTimeout(this.domUpdateTimeout);
    }
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/noimage.png';
  }
}